/**
 * Converts a connector status string to a standardized CSS class name
 *
 * @param {string} status - The status string from the API
 * @returns {string} - Standardized CSS class name: "available", "occupied", or "unavailable"
 */
export const getConnectorStatusClass = (status) => {
    switch (status) {
        case "disponible":
        case "Available":
        case "AvailableFull":
        case "Unavailable":
            return "available";
        case "occupe":
        case "Occupied":
        case "Charging":
        case "OccupiedFull":
        case "UnavailableOccupied":
            return "occupied";
        case "Offline":
        case "indisponible":
        case "UnavailableOccupiedFull":
        case "UnavailableFull":
        default:
            return "unavailable";
    }
};
